/* SIZESOFTX
=========================================================================================
* Descripción: Hook para prevenir doble click en botones
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 21/03/2026 | Lic. José Luis Aragón Cervantes  | Creación
* ---------------------------------------------------------------------------------------
*/

import { useState, useCallback, useRef } from 'react';

export const useDoubleClickPrevention = (delayMs = 1000) => {
    const [isProcessing, setIsProcessing] = useState(false);
    const lastClickTime = useRef(0);

    const executeWithProtection = useCallback((callback) => {
        const now = Date.now();
        if (now - lastClickTime.current < delayMs) {
            return false;
        }
        if (isProcessing) {
            return false;
        }
        
        lastClickTime.current = now;
        setIsProcessing(true);
        
        Promise.resolve(callback())
            .finally(() => {
                setTimeout(() => setIsProcessing(false), delayMs);
            });
        
        return true;
    }, [delayMs, isProcessing]);

    return { isProcessing, executeWithProtection };
};

export default useDoubleClickPrevention;
